import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

export interface LocationAdvantage {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-location',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  locationAdvantages: LocationAdvantage[] = [];

  constructor(public i18n: I18nService) {}

  ngOnInit() {
    this.locationAdvantages = [
      {
        icon: 'fas fa-clock',
        title: this.i18n.getTranslation('location.timezone_title'),
        description: this.i18n.getTranslation('location.timezone_desc')
      },
      {
        icon: 'fas fa-graduation-cap',
        title: this.i18n.getTranslation('location.education_title'),
        description: this.i18n.getTranslation('location.education_desc')
      },
      {
        icon: 'fas fa-dollar-sign',
        title: this.i18n.getTranslation('location.cost_title'),
        description: this.i18n.getTranslation('location.cost_desc')
      },
      {
        icon: 'fas fa-users',
        title: this.i18n.getTranslation('location.culture_title'),
        description: this.i18n.getTranslation('location.culture_desc')
      },
      {
        icon: 'fas fa-shield-alt',
        title: this.i18n.getTranslation('location.eu_title'),
        description: this.i18n.getTranslation('location.eu_desc')
      },
      {
        icon: 'fas fa-rocket',
        title: this.i18n.getTranslation('location.tech_title'),
        description: this.i18n.getTranslation('location.tech_desc')
      }
    ];
  }
}
